<template>
  <v-card class="pb-2 mb-2">
    <v-card-title class="card-title pt-1 pb-1" @click="show = !show" > {{ title }}
     <v-spacer></v-spacer>

    <v-tooltip v-if="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          dark
          v-bind="attrs"
          v-on="on"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <span>{{tooltip}}</span>

    </v-tooltip>

     <v-btn icon>
       <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
     </v-btn>

    </v-card-title>
    <v-divider></v-divider>
    <v-expand-transition>
      <div v-show="show">
        <slot></slot>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
    export default {
        name: 'MenuCard',
        data: function () {
            return { show: true };
        },
        props: ['title', 'tooltip'],
    }
</script>

<style>
.card-title {
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
    cursor: pointer;
}
</style>
